export enum CurrentState {
  NOT_RUNNING,
  REFRESHING_TOC,
  CHECKING_CURRENT_DATA_IN_CACHE,
  CALCULATE_DELTA,
  DELETE_OLD,
  DOWNLOAD,
  FINISHED,
  FINISHED_WITH_ERRORS,
  ABORTED_WITH_ERROR,
}

export interface OfflineUpdateSummary {
  currentState: CurrentState;
  amountInToc?: number;
  amountInCache?: number;
  initialAmountToBeDownloaded?: number;
  initialAmountToBeDeleted?: number;
  leftAmountToBeDownloaded?: number;
}

export function calculateProgressInPercent(s: OfflineUpdateSummary) {
  const left = s.leftAmountToBeDownloaded || 0;
  const initial = s.initialAmountToBeDownloaded || 0;
  if (left === 0 || initial === 0) return 0;
  return Math.round(100 - (left * 100) / initial);
}
